module.exports = __webpack_public_path__ + "static/media/feature_1.efeaf02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_1.png
// module id = 1250
// module chunks = 0